import 'services/firebase'

import {AppRouter} from 'router/AppRouter'
import {GlobalStyle} from 'style/globalStyle'
import {Provider} from 'react-redux'
import React from 'react'
import {Theme} from 'style/Theme'
import {createRoot} from 'react-dom/client'
import {store} from 'state/store'
import {unregister} from 'config/serviceWorker'

const App = () => (
	<Provider store={store}>
		<GlobalStyle />
		<Theme>
			<AppRouter />
		</Theme>
	</Provider>
)

const root = createRoot(document.getElementById('root') as HTMLElement)
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
)

unregister()
